module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-header-card",
    class: _vm.statusType
  }, [_c('div', {
    staticClass: "status-tint"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [_c('div', {
    staticClass: "product-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.imageUrl,
      "alt": _vm.product.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-details"
  }, [_c('h1', {
    staticClass: "product-title"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm._v(" "), _c('div', {
    staticClass: "product-meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.marketplaceLabel))]), _vm._v(" "), (_vm.product.brand) ? _c('span', [_c('span', {
    staticClass: "label"
  }, [_vm._v("Brand: ")]), _vm._v(_vm._s(_vm.product.brand))]) : _vm._e(), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "label"
  }, [_vm._v("ASIN: ")]), _vm._v(_vm._s(_vm.product.asin))])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('span', {
    staticClass: "status-badge",
    class: _vm.statusType
  }, [(_vm.isWon) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })]) : (_vm.isSuppressed) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "4.93",
      "y1": "4.93",
      "x2": "19.07",
      "y2": "19.07"
    }
  })]) : (_vm.isContested) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "17 1 21 5 17 9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 11V9a4 4 0 0 1 4-4h14"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "7 23 3 19 7 15"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 13v2a4 4 0 0 1-4 4H3"
    }
  })]) : _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('line', {
    attrs: {
      "x1": "12",
      "y1": "5",
      "x2": "12",
      "y2": "19"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "19 12 12 19 5 12"
    }
  })]), _vm._v("\n          " + _vm._s(_vm.product.status.label) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "product-stats"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Your Price")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.product.pricing.yourPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("\n        Buy Box Price\n        "), _c('span', {
    staticClass: "tooltip-trigger"
  }, [_c('svg', {
    staticClass: "info-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4M12 8h.01"
    }
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "stat-value",
    class: _vm.bbPriceClass
  }, [_vm._v(_vm._s(_vm.bbPriceDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "stat-subtext",
    class: _vm.bbPriceSubClass
  }, [_vm._v(_vm._s(_vm.bbPriceSub))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("\n        Price Gap\n        "), _c('span', {
    staticClass: "tooltip-trigger"
  }, [_c('svg', {
    staticClass: "info-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4M12 8h.01"
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "stat-value",
    class: _vm.priceGapClass
  }, [_vm._v(_vm._s(_vm.priceGapDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "stat-subtext",
    class: _vm.priceGapSubClass
  }, [_vm._v(_vm._s(_vm.priceGapSub))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("\n        " + _vm._s(_vm.lossLabel) + "\n        "), _c('span', {
    staticClass: "tooltip-trigger"
  }, [_c('svg', {
    staticClass: "info-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4M12 8h.01"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "tooltip-content"
  }, [_c('div', {
    staticClass: "tooltip-title"
  }, [_vm._v(_vm._s(_vm.lossLabel))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lossTooltipText))])])])]), _vm._v(" "), _c('div', {
    staticClass: "stat-value",
    class: _vm.lossValueClass
  }, [_vm._v(_vm._s(_vm.lossValueDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "stat-subtext",
    class: _vm.lossSubClass
  }, [_vm._v(_vm._s(_vm.lossSub))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("\n        FBA Stock\n        "), _c('span', {
    staticClass: "tooltip-trigger"
  }, [_c('svg', {
    staticClass: "info-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4M12 8h.01"
    }
  })]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "stat-value success"
  }, [_vm._v(_vm._s(_vm.product.pricing.fbaStock))]), _vm._v(" "), _c('div', {
    staticClass: "stat-subtext"
  }, [_vm._v("Fulfillable: " + _vm._s(_vm.product.pricing.fbaStock) + " · Transferring: " + _vm._s(_vm.product.pricing.fbaTransferring || 0))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tooltip-content"
  }, [_c('div', {
    staticClass: "tooltip-title"
  }, [_vm._v("Buy Box Price")]), _vm._v(" "), _c('p', [_vm._v("The landed price of the seller currently winning the Buy Box.")]), _vm._v(" "), _c('p', [_vm._v("Shows \"—\" when the Buy Box is suppressed.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tooltip-content"
  }, [_c('div', {
    staticClass: "tooltip-title"
  }, [_vm._v("Price Gap")]), _vm._v(" "), _c('p', [_vm._v("The difference between your price and the Buy Box price. A positive gap means you're priced higher.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tooltip-content"
  }, [_c('div', {
    staticClass: "tooltip-title"
  }, [_vm._v("FBA Stock")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Fulfillable:")]), _vm._v(" Ships today from FC.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Transferring:")]), _vm._v(" Moving between FCs — Amazon can still route orders to these units.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27c64d1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product-details/ProductHeader.vue
// module id = 737
// module chunks = 2